import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=90d7faae&"
import script from "./SignUpView.vue?vue&type=script&lang=ts&"
export * from "./SignUpView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90d7faae')) {
      api.createRecord('90d7faae', component.options)
    } else {
      api.reload('90d7faae', component.options)
    }
    module.hot.accept("./SignUpView.vue?vue&type=template&id=90d7faae&", function () {
      api.rerender('90d7faae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/guest/gsx/SignUpView.vue"
export default component.exports